import {Box, Flex, Tag} from 'exsportia-components'
import React, {FC, useState} from 'react'

import {AMENITY_TYPE_MAP} from '../../constants/amenities'
import {useLocale} from '../../utils/i18n'
import {isNilOrEmpty} from '../../utils/logic'
import {icons} from './icons'

type Props = {
  amenities: string[] | null
};

const AMENITIES_TO_SHOW = 10
export const Amenities: FC<Props> = ({amenities}) => {
  const [showAll, setShowAll] = useState(false)
  const {l} = useLocale()
  if (isNilOrEmpty(amenities)) {
    return null
  } // TODO: Replace with nice look skeleton
  const amenitiesLength = amenities.length
  const canToggle = (amenitiesLength) > AMENITIES_TO_SHOW
  const numberOfHiddenAmenities = amenitiesLength - AMENITIES_TO_SHOW
  const collapseText = showAll
    ? l('showLess')
    : `+${numberOfHiddenAmenities} ${l('showMore', {value: numberOfHiddenAmenities})}`

  return (
    <Flex
      width={'100%'}
      position='relative'
      flexDirection='column'
      justifyContent='space-between'
    >
      <Flex
        py='8'
        flexDirection='row'
        flexWrap='wrap'
        gap='8px'
      >
        {
          (
            (showAll || !canToggle)
              ? amenities
              : amenities.slice(0, AMENITIES_TO_SHOW)
          ).map((item: string, index: number) => {
            const params = AMENITY_TYPE_MAP[item]
            const label = l(params.label)
            const icon = icons[params.icon]({color: 'primary'})
            return (
              <Tag
                key={index}
                icon={icon}
                styleType='displayValue'
                text={label}
              />
            )
          })
        }
        {
          canToggle
          && (
            <Box onClick={() => setShowAll(!showAll)}>
              <Tag
                text={collapseText}
                styleType='displayValue'
              />
            </Box>
          )
        }
      </Flex>
    </Flex>
  )
}
